<template>
  <div class="load-simulation-data">
    <div class="load-simulation-data__title">
      <label class="m-0">
        {{ $t('engineering.load-simulation.scenario-repetitions') }}
      </label>
    </div>
      <div class="p-3">
        <b-form-group
          class="mb-0"
          label-class="font-weight-bold"
          :label="`${$t('fields.engineering.load-simulation.scenario-repetitions')}*`"
        >
          <s-number-input
            id="load-simulation-data-interval"
            class="load-simulation-data__repetitions text-right"
            v-model="$v.simulationRepetitionsNumber.$model"
            :validation="$v.simulationRepetitionsNumber"
            :numeric-options="getNumericPrecision()"
            :disabled="loading"
            @blur-native-proxy="$v.simulationRepetitionsNumber.$touch()"
            @input="onChangeRepetitions"
          />
          <b-form-invalid-feedback
            class="d-block"
            v-if="$v.simulationRepetitionsNumber.$error"
          >
            {{ getMA086() }}
          </b-form-invalid-feedback>
        </b-form-group>
      </div>
  </div>
</template>
<script>
import store from '@/store';
import { required, between } from 'vuelidate/lib/validators';
import dataFields from '@/domain/data/installation/engineering/loadSimulation/dataFields';

export default {
  name: 'LoadSimulationDataPointsTable',
  props: {
    repetitions: {
      type: Number,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data: vm => ({
    dataFields,
    simulationRepetitionsNumber: vm.repetitions,
  }),
  validations() {
    return {
      simulationRepetitionsNumber: {
        required,
        between: between(
          dataFields.simulationRepetitionsNumber.minValue,
          dataFields.simulationRepetitionsNumber.maxValue,
        ),
      },
    };
  },
  computed: {
    invalid() {
      return this.$v.$invalid;
    },
  },
  methods: {
    getNumericPrecision() {
      const precision = dataFields.simulationRepetitionsNumber.precision || 0;
      return ({
        decimalPlaces: precision,
      });
    },
    getMA086() {
      return this.$t('messages.MA086.message', {
        minValue: this.$n(dataFields.simulationRepetitionsNumber.minValue),
        maxValue: this.$n(dataFields.simulationRepetitionsNumber.maxValue),
      });
    },
    onChangeRepetitions(value) {
      store.dispatch('setSimulationDataRepetitions', value);
      store.dispatch(
        'setSimulationDataIsRepetitionsInvalid',
        this.$v.simulationRepetitionsNumber.$invalid,
      );
    },
  },
};
</script>
<style scoped lang="sass">
.load-simulation-data
  border: 1px solid var(--color-table-header-bg)
  border-radius: 4px

  &__title
    background-color: var(--color-background-dark)
    padding: 0.6rem 1rem !important
    cursor: pointer
    border-top-left-radius: 5px
    border-top-right-radius: 5px
    position: relative

  &__repetitions
    max-width: 11em

</style>
